const NoMatch = () => {
  return <div>404</div>;
};

export default NoMatch;
